import type { Robot } from '$lib/patterns/strategy/examples/types';
type Message = Robot.Message;
import Dad_Joke_Bot_Maker from './shared/inheritance/Dad_Joke_Bot';
import Stoicism_Bot_Maker from './shared/inheritance/Stoicism_Bot';
import Comedian_Bot_Maker from './shared/inheritance/Comedian_Bot';
import { Cache } from './shared/Cache';








abstract class Chatbot {

	abstract readonly name: string;
	abstract readonly avatar: string;

	abstract getContent(): Promise<string>;
	async getMessage(): Promise<Message> {

		const cachedBots = [
			'Dad Joke Bot',
			'Stoicism Bot',
		];

		let content;
		let cachedMessage = `[${this.name}] Cache: NONE`;

		if (cachedBots.includes(this.name)) {
			content = Cache.get(this.name);
			cachedMessage = `[${this.name}] Cache: HIT`
		}

		if (!content) {
			content = await this.getContent();
			if (cachedBots.includes(this.name)) {
				Cache.set(this.name, content);
			}
			cachedMessage = `[${this.name}] Cache: MISS`;
		}

		return {
			author: this.name,
			avatar: this.avatar,
			log: cachedMessage,
			time: new Date().toLocaleTimeString(),
			content: content,
		};

	}
}

const Dad_Joke_Bot = Dad_Joke_Bot_Maker(Chatbot);
const Stoicism_Bot = Stoicism_Bot_Maker(Chatbot);
const Comedian_Bot = Comedian_Bot_Maker(Chatbot);

export default {
	Chatbot: {
		class: Chatbot,
	},
	Dad_Joke_Bot: {
		class: Dad_Joke_Bot,
		init: () => new Dad_Joke_Bot(),
	},
	Stoicism_Bot: {
		class: Stoicism_Bot,
		init: () => new Stoicism_Bot(),
	},
	Comedian_Bot: {
		class: Comedian_Bot,
		init: () => new Comedian_Bot(),
	},
};